module.exports = __webpack_public_path__ + "static/media/instluminariasmini.57dac8bd.webp";